export default class NewsletterController {
    constructor($scope, $http) {
        this.$scope = $scope;
        this.$http = $http;

        this.name = '';
        this.email = '';
        this.i_agree = true;
        this.sent = false;
        this.sending = false;
        this.alerts = [];
    }

    $onInit() {
        console.log('ok!!');
    }

    submit() {
        this.$scope.newsletter.$setSubmitted();

        if (this.$scope.newsletter.$invalid) {
            return;
        }

        this.sending = true;
        this.alerts = [];
        this.$http.post('/api/newsletter/subscribe', {
            'name': this.name,
            'email': this.email,
            'website': '',
            'g-recaptcha-response': document.getElementById('newsletter-g-recaptcha-token').value
        }).then(response => {
            if (response.data.success) {
                if (response.data.data.type === 'success') {
                    this.sent = true;
                }
                this.alerts.push({msg: response.data.data.message, type: response.data.data.type})
            } else {
                this.alerts.push({msg: 'An unknown error has occurred. Try again later.', type: 'danger'})
            }
            this.sending = false;
        }, errorResponse => {
            for (let field in errorResponse.data.errors) {
                this.alerts.push({
                    msg: '<strong>' + field + ':</strong> ' + errorResponse.data.errors[field],
                    type: 'danger'
                })
            }
        });
    }
}

NewsletterController.$inject = ['$scope', '$http'];
